import { render, staticRenderFns } from "./SimpleNavbar.vue?vue&type=template&id=3a080d12&scoped=true&"
import script from "./SimpleNavbar.vue?vue&type=script&lang=js&"
export * from "./SimpleNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SimpleNavbar.vue?vue&type=style&index=0&id=3a080d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a080d12",
  null
  
)

export default component.exports